<db-panel>
    <div class="db-panel__title">
        {{ 'GLOBAL.logging_in' | translate }}...
    </div>
    <div class="db-panel__container">
        <div class="logging-in-container">
            <db-spinner></db-spinner>
        </div>
    </div>
</db-panel>